<template lang="pug">
  #map
    v-container.pa-0(fluid, grid-list-xs, text-xs-center)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            #mapid
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
import L from "leaflet";

export default {
  name: "Map",
  components: {
    Tooltip,
  },
  data() {
    return {
      markers: [],
      mymap: undefined,
      markerLayer: undefined,
      legend: undefined,
      stateColors: this.$store.state.stateColors,
      aggressionsTypes: this.$store.state.aggressionsTypes,
    };
  },
  computed: {
    reports: function () {
      return this.$store.state.reports;
    },
  },
  watch: {
    "$store.state.selection": function () {
      if (this.$store.state.selection)
        this.markers
          .find((marker) => {
            return marker.folio == this.$store.state.selection;
          })
          .fire("click");
      else this.mymap.closePopup();
    },
    "$store.state.reports": function () {
      this.drawMarkers();
      this.drawLegend();
    },
  },
  methods: {
    drawMap() {
      this.mymap = L.map("mapid").setView([23.6345, -102.5528], 5);
      this.mymap.scrollWheelZoom.disable();

      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          tileSize: 512,
          maxZoom: 18,
          zoomOffset: -1,
          id: "mapbox/streets-v11",
          accessToken:
            "pk.eyJ1Ijoiam9yYW5kcmFkZWZpZyIsImEiOiJjamV0bm9vczAzMTc3MnlvMG4wMTBlaXY0In0.6Te0HBRHyNH0TAVIQNT89w",
        }
      ).addTo(this.mymap);

      this.mymap.on("popupclose", () => {
        this.$store.commit("setSelection", undefined);
      });
      this.drawMarkers();
      this.drawLegend();
    },
    drawMarkers() {
      this.markers = [];
      if (this.markerLayer) {
        this.markerLayer.clearLayers();
      }

      this.reports.forEach((report) => {
        if (report.marker.length > 0) {
          const type = this.aggressionsTypes.filter((obj) => {
            return report.type === obj.title;
          })[0];
          let color = type ? type.color : "#4A90E2";

          const svg = `
          <?xml version="1.0" encoding="UTF-8"?>
          <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
              <title>Shape</title>
              <desc>Created with Sketch.</desc>
              <defs>
                  <path d="M738,1112 C731.918571,1112 727,1116.5385 727,1122.15 C727,1129.7625 738,1141 738,1141 C738,1141 749,1129.7625 749,1122.15 C749,1116.5385 744.081429,1112 738,1112 L738,1112 Z M734,1122 C734,1119.792 735.7248,1118 737.85,1118 C739.9752,1118 741.7,1119.792 741.7,1122 C741.7,1124.208 739.9752,1126 737.85,1126 C735.7248,1126 734,1124.208 734,1122 Z" id="path-1"></path>
                  <filter x="-31.8%" y="-17.2%" width="163.6%" height="148.3%" filterUnits="objectBoundingBox" id="filter-2">
                      <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                      <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                      <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.258520154 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                  </filter>
              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="RRM_back02" transform="translate(-723.000000, -1110.000000)">
                      <g id="Shape">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <use fill="${color}" fill-rule="evenodd" xlink:href="#path-1"></use>
                      </g>
                  </g>
              </g>
          </svg>
          `;

          const icon = L.divIcon({
            className: "pin",
            html: svg,
            iconAnchor: [16, 34],
            popupAnchor: [0, -35],
          });
          const marker = L.marker(report.marker, { icon: icon });

          marker.bindPopup(
            '<div data-v-70596efa="" class="container pa-0 grid-list-xs"><div data-v-70596efa="" class="layout ma-0 pa-0 row wrap"><div data-v-70596efa="" class="tooltip ma-0 pa-0 card card--flat" style="height: auto;"><div data-v-70596efa="" class="layout ma-0 pa-0 fluid row wrap"><div data-v-70596efa="" class="flex pa-0 xs4"><div data-v-70596efa="" class="card__text data folio pb-0 pt-1">#' +
              report.folio +
              '</div><div data-v-70596efa="" class="card__text data pt-0 pb-0">' +
              report.date +
              '</div><div data-v-70596efa="" class="card__actions d-flex pb-1 pt-2"><button data-v-70596efa="" type="button" class="view btn btn--flat" justify-center="" onclick="window.open(\'https://s3.amazonaws.com/images.rompeelmiedo.org/' +
              report.folio +
              '.png\', \'_blank\')"; return false;"><div class="btn__content">VER POSTAL</div></button></div></div><div data-v-70596efa="" class="flex pa-0 xs8"><div data-v-70596efa="" class="card__title pa-1 card__title--primary"><div data-v-70596efa="" class="title"><h3 data-v-70596efa="" class="headline mb-0">' +
              report.state +
              ' /&nbsp;<span data-v-70596efa="" class="mun">' +
              report.municipality +
              '</span></h3><span data-v-70596efa="" class="type">' +
              report.type +
              '</span></div></div><div data-v-70596efa="" class="card__text description pa-1">' +
              report.details +
              "</div></div></div></div></div></div>"
          );

          marker.folio = report.folio;
          this.markers.push(marker);
          marker.on("click", (e) => {
            const folio = e.sourceTarget.folio;
            this.$store.commit("setSelection", folio);
            marker.openPopup();
          });
        }
      });

      this.markerLayer = L.featureGroup(this.markers).addTo(this.mymap);
    },
    drawLegend() {
      if (this.legend) {
        this.legend.remove();
      }
      this.legend = L.control({ position: "bottomleft" });

      this.legend.onAdd = () => {
        const div = L.DomUtil.create("div", "info legend");

        // loop through our density intervals and generate a label with a colored square for each interval
        this.aggressionsTypes.forEach((type) => {
          const reports = this.reports.filter((report) => {
            return type.title === report.type;
          });
          if (reports.length > 0) {
            div.innerHTML += `<div>
                  <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                    <title>Shape</title>
                    <desc>Created with Sketch.</desc>
                    <defs>
                      <path d="M738,1112 C731.918571,1112 727,1116.5385 727,1122.15 C727,1129.7625 738,1141 738,1141 C738,1141 749,1129.7625 749,1122.15 C749,1116.5385 744.081429,1112 738,1112 L738,1112 Z M734,1122 C734,1119.792 735.7248,1118 737.85,1118 C739.9752,1118 741.7,1119.792 741.7,1122 C741.7,1124.208 739.9752,1126 737.85,1126 C735.7248,1126 734,1124.208 734,1122 Z" id="path-1"></path>
                      <filter x="-31.8%" y="-17.2%" width="163.6%" height="148.3%" filterUnits="objectBoundingBox" id="filter-2">
                        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.258520154 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                      </filter>
                    </defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="RRM_back02" transform="translate(-723.000000, -1110.000000)">
                        <g id="Shape">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <use fill="${type.color}" fill-rule="evenodd" xlink:href="#path-1"></use>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <p class="text-xs-left mb-0 pl-2">${type.title}</p>
                </div>`;
          }
        });

        return div;
      };

      this.legend.addTo(this.mymap);
    },
  },
  mounted() {
    this.drawMap();
  },
};
</script>

<style lang="scss">
@import "../app.scss";
#mapid {
  height: 600px;
  z-index: 0;
  .legend {
    width: 350px;
    border-radius: 10px;
    padding: 15px;
  }
  .legend i {
    width: 18px;
    height: 18px;
    float: left;
    margin-right: 8px;
    opacity: 0.7;
  }
  .legend div {
    display: flex;
    align-items: center;
    background-color: transparent;
  }
  .legend svg {
    height: 30px;
    width: 30px;
  }
  .legend p {
    width: 300px;
    line-height: 18px;
    color: white;
    text-transform: uppercase;
    font-family: "Rajdhani", sans-serif;
    font-size: 16px;
  }
  .info.legend {
    background-color: #494949dd !important;
    border-color: #494949dd !important;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0px;
    width: 425px;
    height: 158px;
    border: solid 4px #c1d542;
    background-color: #f8f8f8;
    font-family: "Rajdhani", sans-serif;
    .container {
      display: block;
      position: absolute;
      left: 4px;
      top: 4px;
      .layout {
        width: 417px;
        height: 150px;
        background-color: #f8f8f8;
        .tooltip {
          .data {
            color: $light-text;
            font-weight: 600;
            font-size: 1.3rem;
            &.folio {
              font-size: 1.5rem !important;
            }
          }
          .view {
            border: 1.5px solid $medium-text;
            border-radius: 5px;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
            color: $medium-text !important;
            max-width: 80%;
            font-size: 1rem;
            font-weight: 700;
            padding-top: 0;
          }
          .title {
            color: $dark-title;
            h3 {
              font-family: "Barlow Semi Condensed", sans-serif !important;
              font-weight: 600;
              .mun {
                font-weight: 500;
              }
            }
            .type {
              font-size: 16px !important;
              font-weight: 500 !important;
            }
          }
          .description {
            color: $dark-text;
            padding-top: 0;
            font-size: 1.1rem;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
}

@media (max-width: 576px) {
  #map {
    display: none;
  }
}
</style>
